/** Static tips appended to the AI analysis (product copy). */

export const AI_TIPS_SECTION_TITLE = 'טיפים';

export const AI_TIP_ILA = {
  title: 'העברת בעלות מרמ"י לבעלות פרטית',
  body:
    'כאשר הנכס רשום בחכירה מול רשות מקרקעי ישראל, ייתכן שניתן לבצע העברת בעלות מחכירה לבעלות פרטית במסגרת רפורמת רמ"י. במקרים מתאימים, בעיקר בדירות בבנייה רוויה שבהן החכירה מהוונת, ניתן להגיש בקשה לרמ"י, לקבל שטרי מכר חתומים ולרשום את הבעלות בטאבו. מעבר זה עשוי לפטור בעתיד מתשלומים כמו דמי הסכמה ודמי היתר מול רמ"י.',
  disclaimer:
    'הזכאות תלויה בסוג הנכס, סטטוס ההיוון ותנאי הרפורמה. בבנייה נמוכה או במקרים מסוימים ייתכן שיידרש תשלום. המידע כללי בלבד ואינו מהווה ייעוץ משפטי.',
};

export const AI_TIP_TABU = {
  title: 'הוצאת נסח טאבו ומעקב אחר רישומים',
  body:
    'מומלץ להוציא נסח טאבו עדכני של הנכס כדי לוודא את פרטי הרישום, הבעלות, הזכויות וההערות הרשומות עליו. נסח עדכני יכול לסייע בזיהוי פערים, מגבלות או אינדיקציות שחשוב להכיר לפני קידום מהלך בנכס.',
  followUp:
    'בנוסף, מומלץ לוודא שהנכס רשום ומעודכן בטאבו, כדי לשפר את היכולת לעקוב אחר שינויים ברישום ובמקרים הרלוונטיים לקבל התראות על פעולות כמו רישום הערות אזהרה.',
};
